import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const Item = styled.div`
  display: flex;
  padding: var(--space-200) 0;
  align-items: flex-start;
  gap: var(--space-600);
  align-self: stretch;
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-300);
  flex: 1 0 0;

  a {
    text-decoration: underline;
  }
`

export const Value = styled.div`
  color: var(--text-primary);
  text-align: right;
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
  min-width: 80px;
`

export const ChangeValue = styled.div`
  display: flex;
  width: 64px;
`
